export const DEFAULT_CHAT_FORM_DISCLAIMER =
  'By submitting this form, you agree that we may contact you using the information provided, including by email, phone, or text message.';

export const DEFAULT_CHAT_FORM_FIELDS = [
  { name: 'Name', label: 'Full Name', type: 'text', required: true, placeholder: 'John Smith' },
  { name: 'Email', label: 'Email Address', type: 'email', required: true, placeholder: 'you@example.com' },
];

export const CHAT_FORM_FIELD_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'email', label: 'Email' },
  { value: 'tel', label: 'Phone' },
];

export const sanitizeChatFormFieldName = (name) =>
  name.replace(/[^a-zA-Z0-9_\s]/g, '').replace(/\s+/g, '_');

export const chatFormFieldsToPayload = (fields) =>
  (fields || []).map(({ name, label, type, required, placeholder }) => ({
    name,
    label,
    type: type || 'text',
    required: required !== false,
    placeholder: placeholder || '',
  }));

export const withChatFormParams = (url, agent) => {
  if (!agent?.chat_embed_form_enabled) return url;
  const fields = agent.chat_embed_form_fields;
  if (!Array.isArray(fields) || fields.length === 0) return url;
  const paramStr = fields
    .filter((f) => f.name?.trim())
    .map((f) => `${encodeURIComponent(f.name)}=`)
    .join('&');
  if (!paramStr) return url;
  return `${url}${url.includes('?') ? '&' : '?'}${paramStr}`;
};
